module.exports = __webpack_public_path__ + "kyc.1eb5e79c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/kyc.png
// module id = 2493
// module chunks = 0